<template>
    <div>
    <h2>License Summary</h2>
    <p class="help-text"><strong>This summary is not a license text and by no means is a legal advice.</strong>
        We recommend you to talk to your lawyer if you have any doubts whether your intended usage
        complies with GPL3 or any other license applicable to GanttProject code or its libraries.</p>
    <ul class="help-text">
        <li>You may use unmodified binaries for any purposes, including commercial usage.</li>
        <li>You don't have to pay anything for using GanttProject.</li>
        <li>You may redistribute unmodified binaries freely.</li>
        <li>GanttProject source code and all required libraries are available to
            everyone. You are allowed to download and modify the sources of GanttProject and
            build your own modified binaries.</li>
        <li>If you redistribute modified binaries of GanttProject, you must provide all the sources to
            the receiver of a binary copy on his first request.
            Modifications should be published under GPL3.</li>
        <li>If you don't make your modifications publicly available, you don't have to publish the modified sources.</li>
    </ul>

    <a class="btn btn-attention-outline" href="https://www.gnu.org/licenses/gpl-3.0.en.html" target="_blank">Read GPL3 License Text</a>
    </div>
</template>

<script>
    export default {
        name: "License"
    }
</script>

<style scoped>

</style>
